import { LogoMega } from './LogoMega'
import estilos from './MarcaMega.module.css'

/**
 * Bloque de marca completo: logo + nombre + descriptor.
 * Se usa en la cabecera del menú lateral y en la pantalla de ingreso.
 */

type PropsMarca = {
  /** El menú lateral es morado oscuro; la pantalla de ingreso es clara. */
  fondo?: 'oscuro' | 'claro'
  tamanoLogo?: number
  /** En el menú colapsado se muestra solo el logo. */
  soloLogo?: boolean
}

export function MarcaMega({ fondo = 'oscuro', tamanoLogo = 40, soloLogo = false }: PropsMarca) {
  const clases = [estilos.marca, fondo === 'claro' ? estilos.sobreClaro : '']
    .filter(Boolean)
    .join(' ')

  return (
    <div className={clases}>
      {/* Sobre fondo oscuro va la variante completa: el isotipo es morado y
          sin el disco blanco del anillo se funde con el fondo del menú. */}
      <LogoMega tamano={tamanoLogo} variante={fondo === 'oscuro' ? 'completo' : 'marca'} />

      {!soloLogo && (
        <div className={estilos.texto}>
          <div className={estilos.nombre}>MEGA</div>
          <div className={estilos.descriptor}>
            Distribuciones y
            <br />
            Proyectos S.A.S.
          </div>
        </div>
      )}
    </div>
  )
}
